module.exports = __webpack_public_path__ + "static/media/responsive_headline.759b70d4.svg";